import { Box } from 'braid-design-system';
import { memo } from 'react';

import type { AuthenticatedType } from 'src/hooks/useAuthenticated';
import type { SearchViewModelCompanySuggestion } from 'src/store/results/types';

import NewToYouSignIn from '../NewToYouSignIn/NewToYouSignIn';
import UpToDateZeroCount from '../UpToDateZeroCount/UpToDateZeroCount';
import ZeroResults from '../ZeroResults/ZeroResults';

import * as styles from './SplitView.css';

export default memo(
  ({
    authenticateState,
    isNewToYou,
    isZeroResults,
    companySuggestion,
  }: {
    authenticateState: AuthenticatedType;
    isNewToYou: boolean;
    isZeroResults: boolean;
    companySuggestion?: SearchViewModelCompanySuggestion;
  }) => {
    let message;

    if (isNewToYou) {
      if (authenticateState === 'unauthenticated') message = <NewToYouSignIn />;

      if (authenticateState === 'authenticated' && isZeroResults)
        message = <UpToDateZeroCount />;
    } else if (isZeroResults) {
      message = <ZeroResults companySuggestion={companySuggestion} />;
    }

    return message ? (
      <Box className={styles.LoadingWrapItem} marginTop="xxxlarge">
        <Box
          data-automation="behavioural-cues-filters-message"
          width="full"
          className={styles.content}
        >
          {message}
        </Box>
      </Box>
    ) : null;
  },
);
